import React from 'react';
import { useSelector } from 'react-redux';
import { setScreenName } from '../utils/tracking';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import section
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';

// import components
import GenericMetadata from 'js/components/generic/Generic.metadata';
import HeaderHome from 'js/components/header/Header.home';
import TransitionPage from 'js/containers/transition/Transition.page';
import ActivityCardCarousel from 'js/components/activity-card/ActivityCard.carousel';
import CollectionCarousel from 'js/components/collections/Collections.carousel';

// import selectors
import { getUserFavoritedCards, getUserRecentlyViewedCards, getAllCards } from 'js/store/cards/Cards.selectors';
import { getTranslationById, getSiteMetaData } from 'js/store/app/App.selectors';

const PageHome = ({ path }) => {
  const favoritedCards = useSelector((state) => getUserFavoritedCards(state));
  const recentlyViewedCards = useSelector((state) => getUserRecentlyViewedCards(state));
  const allCards = useSelector((state) => getAllCards(state));
  const siteMetaData = useSelector((state) => getSiteMetaData(state, path));

  const siteText = {
    favorites: useSelector((state) => getTranslationById(state, 'home_page_category_favorites', 'Favorites')),
    suggestedCollections: useSelector((state) =>
      getTranslationById(state, 'home_page_category_suggested_collections', 'Suggested Collections')
    ),
    recentActivity: useSelector((state) =>
      getTranslationById(state, 'home_page_category_recent_activity', 'Recent Activity')
    ),
    allCards: useSelector((state) => getTranslationById(state, 'home_page_category_all_cards', 'All cards')),
  };

  React.useEffect(() => {
    setScreenName('Home');
    setBodyBackgroudColor('#8FCCF1');
  }, []);

  return (
    <TransitionPage>
      <GenericMetadata
        title={siteMetaData.title}
        description={siteMetaData.description}
        keywords={siteMetaData.keywords}
      />
      <SectionPageWrapper className={'page--home'} bgColor={'#8FCCF1'}>
        <HeaderHome />
        <ActivityCardCarousel title={siteText.favorites} cards={favoritedCards} url="/favorites" />

        <CollectionCarousel title={siteText.suggestedCollections} type="curated" />
        <ActivityCardCarousel title={siteText.recentActivity} cards={recentlyViewedCards} url="/recent" />

        <ActivityCardCarousel title={siteText.allCards} cards={allCards} url="/all-cards" type={'all-cards'} />
      </SectionPageWrapper>
    </TransitionPage>
  );
};

export default PageHome;
